import React from 'react';

//common
import { SwitchItem } from "@ui-partents/SwitchButton";

function ButtonSwitchChatWrapup(props) {
    return (
        <SwitchItem
            {...props}
            label={`Enable Chat Wrap-up in Learner Interface`}
            name={`ChatWrapup`}
        />
    );
};

export default ButtonSwitchChatWrapup;